import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {MatRadioChange} from '@angular/material/radio';
import {ReportParameterModel} from '../models/ReportParameterModel.model';
import { DomSanitizer } from '@angular/platform-browser';
import {ReportViewerParameterModel} from '../models/ReportViewerParameterModel.model';
import {ReportsService} from '../reports.service';
import {ReportModel} from '../models/ReportModel.model';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ReportCategoryModel} from '../models/ReportCategoryModel.model';
import {ReportsEntryModel} from '../models/ReportsEntryModel.model';
import {DataTypeEnum} from '../../../models/enum/data-type.enum';
import {ReportViewerDialogComponent} from '../report-viewer-dialog/report-viewer-dialog.component';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {MatRadioGroup} from '@angular/material/radio';

@Component({
  selector: 'app-report-viewer',
  templateUrl: './report-viewer.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: [
    './report-viewer.component.css',
    '../../../../../node_modules/jquery-ui/themes/base/all.css',
    '../../../../../node_modules/devextreme/dist/css/dx.common.css',
    '../../../../../node_modules/devextreme/dist/css/dx.light.css',
    '../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.common.css',
    '../../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.light.css',
    '../../../../../node_modules/devexpress-reporting/dist/css/dx-webdocumentviewer.css'
  ]
})
export class ReportViewerComponent implements OnInit {

  constructor(
    public domSanitizer: DomSanitizer,
    private reportService: ReportsService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,

  ) { }

  @Input() reportViewerEntry: ReportsEntryModel;
  patientId: string;

  // Use this line if you use an ASP.NET MVC backend
  // invokeAction = '/WebDocumentViewer/Invoke';
  // Use this line if you use an ASP.NET Core backend
  invokeAction = 'DXXRDV';

  title = 'DXReportViewer';
  reportUrl: string;
  reportToPDFUrl: string;
  hostUrl = 'https://localhost:44321/';
  // hostUrl = 'https://localhost:44387/';
  reportName = 'No Report Selected';
  firstNameParam = '';
  locidParam = '';
  reports: ReportModel[] = [];
  reportCategories: ReportCategoryModel[] = [];
  isLoading: boolean;

  activeReport: ReportModel;

  reportViewerParameters: ReportViewerParameterModel[] = [];
  reportParameters: ReportParameterModel[] = [];
  reportParametersNumber: ReportParameterModel[] = [];
  reportParametersString: ReportParameterModel[] = [];
  reportParametersBoolean: ReportParameterModel[] = [];
  reportParametersDateTime: ReportParameterModel[] = [];

  ngOnInit(): void {



    // get reports
    this.reportService.getReports()
      .subscribe(response => {

        // reports
        this.reports = response;

        // report categories
        this.reports.forEach(a => {
          if (!this.reportCategories.find(f => f.enumReportCategoryID === a.enumReportCategoryID)) {
            const reportCategory: ReportCategoryModel = new ReportCategoryModel();
            reportCategory.enumReportCategoryID = a.enumReportCategoryID;
            this.reportCategories.push(reportCategory);
          }
        });

      }, err => {
        this.showMessage('Error', 'Error getting reports');
        this.isLoading = false;
      });

    // get report category types

  }

  resetParamVars() {
    this.reportParameters = [];
    this.reportParametersNumber = [];
    this.reportParametersString = [];
    this.reportParametersNumber = [];
    this.reportParametersDateTime = [];
  }

  reportSelected(event: MatRadioChange): void {

    // set active
    this.activeReport = event.value;

    // reset report param vars
    this.resetParamVars();

    // present any parameter inputs
    if (this.activeReport.cfgReportParameters) {
      this.activeReport.cfgReportParameters.forEach(a => {

        // load up params based on type
        if (a.enumDataTypeID) {
          if (a.enumDataTypeID === DataTypeEnum.String) {
            this.reportParametersString.push(a);
          }
          else if (a.enumDataTypeID === DataTypeEnum.Integer) {
            this.reportParametersNumber.push(a);
          }
          else if (a.enumDataTypeID === DataTypeEnum.Boolean) {
            this.reportParametersBoolean.push(a);
          }
          else if (a.enumDataTypeID === DataTypeEnum.DateTime) {
            this.reportParametersDateTime.push(a);
          }
        }
      });
    }
  }

  runReport(): void {

    // get report path
    this.reportUrl = this.returnReportPath();

    // and just for now...
    this.reportName = this.reportUrl;
  }

  runReportToPDF(): void {
    this.reportToPDFUrl = this.hostUrl + 'ReportExport/ExportPDF?reportUrl=' + this.returnReportPath();
    this.goToLink(this.reportToPDFUrl);
  }

  goToLink(url: string): void {
    window.open(url, '_blank');
  }

  returnReportPath(): string {
    // report path return
    let reportPath = '';

    // build params for report
    reportPath = this.activeReport.ServerReportName;
    this.reportViewerParameters = [];
    let params = '';

    // if params entered

    // string params
    this.reportParametersString.forEach(a => {
      if (a.ParameterValueString) {
        const viewerParam = new ReportViewerParameterModel();
        viewerParam.value = a.ParameterValueString;
        viewerParam.name = a.ParameterName;
        this.reportViewerParameters.push(viewerParam);
      }
    });

    // number params
    this.reportParametersNumber.forEach(a => {
      if (a.ParameterValueNumber) {
        const viewerParam = new ReportViewerParameterModel();
        viewerParam.value = a.ParameterValueNumber.toString();
        viewerParam.name = a.ParameterName;
        this.reportViewerParameters.push(viewerParam);
      }
    });

    // boolean params
    this.reportParametersBoolean.forEach(a => {
      if (a.ParameterValueBoolean) {
        const viewerParam = new ReportViewerParameterModel();
        viewerParam.value = a.ParameterValueBoolean.toString();
        viewerParam.name = a.ParameterName;
        this.reportViewerParameters.push(viewerParam);
      }
    });

    // date params
    this.reportParametersDateTime.forEach(a => {
      if (a.ParameterValueDate) {
        const viewerParam = new ReportViewerParameterModel();
        viewerParam.value = a.ParameterValueDate.toString();
        viewerParam.name = a.ParameterName;
        this.reportViewerParameters.push(viewerParam);
      }
    });

    if (this.reportViewerParameters.length) {
      this.reportViewerParameters.forEach(item => {
        params += '&' + item.name + '=' + item.value;
      });
      params = params.replace('&', '?');
    }

    // finally, append params to url
    reportPath += params;

    // alert(reportPath);
    // alert(this.hostUrl);

    // return report path
    return reportPath;
  }

  showMessage(type, message) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  showDialog() {

    const config = new MatDialogConfig();
    config.width = '1300px';
    config.height = '900px';
    config.data = {
      patientId: 'testing',
    };
    config.panelClass = 'dialog';

    const reportViewer = this.dialog.open(ReportViewerDialogComponent, config);
  }

  transformReportName(reportName: string): string {
    return reportName.toLowerCase().replace(/\s+/g, '-');
  }
}
